import L from 'leaflet';
import * as moment from 'moment';
import 'moment/locale/ru';

import { Coordinate } from "./coordinate";
import { Route } from "./route";
import { ILeafletObject } from "../common/index";
import { StopSchedule } from './schedule';

import { environment } from '../../environments/environment';

export class Stop {
    id: number;
    name: string;
    coordinate: Coordinate;
}

export class ScheduledStop extends Stop {
    arrivalMoment?: Date;

    isActive: boolean;
    isSelected: boolean = false;
    isPassed: boolean = false;

    constructor(stop: Stop) {
        super();

        this.id = stop.id;
        this.name = stop.name;
        this.coordinate = stop.coordinate;
    }
}

export class LeafletStop extends Stop implements ILeafletObject {
    private defaultOptions: any;
    private selectionOptions: any;
    private highlightOptions: any;
    private selectionStartOptions: any;
    private selectionFinishOptions: any;
    private selectionGoBetweenOptions: any;
    private _selectionType: StopSelectionType;

    get selectionType(): StopSelectionType {
        return this._selectionType;
    }

    // circleBackground: L.Circle;
    circle: L.Circle;

    isSelected: boolean = false;

    constructor(stop: LeafletStop | Stop) {
        super();

        this.id = stop.id;
        this.name = stop.name;
        this.coordinate = stop.coordinate;

        if (stop instanceof LeafletStop) {
            this._selectionType = stop._selectionType;
            this.defaultOptions = stop.defaultOptions;
            this.selectionOptions = stop.selectionOptions;
            this.highlightOptions = stop.highlightOptions;
            this.selectionStartOptions = stop.selectionStartOptions;
            this.selectionFinishOptions = stop.selectionFinishOptions;
            this.selectionGoBetweenOptions = stop.selectionGoBetweenOptions;
            this.circle = stop.circle;
        } else {
            this._selectionType = StopSelectionType.None;

            if (environment.map && environment.map.stop && environment.map.stop.style) {
                this.defaultOptions = environment.map.stop.style.default;
                this.selectionOptions = environment.map.stop.style.selected;
                this.highlightOptions = environment.map.stop.style.highlighted;

                if (environment.map.stop.style.edge) {
                    this.selectionStartOptions = environment.map.stop.style.edge.start;
                    this.selectionFinishOptions = environment.map.stop.style.edge.finish;
                    this.selectionGoBetweenOptions = environment.map.stop.style.edge.gobetweeen;
                }

                let coordinate = L.latLng(stop.coordinate.latitude, stop.coordinate.longitude);
                this.circle = L.circleMarker(coordinate, this.defaultOptions);
            }
        }
    }

    highlight() {
        if (this.highlightOptions)
            this.circle.setStyle(this.highlightOptions);
    }

    unhighlight() {
        if (this.isSelected === true) {
            switch (this._selectionType) {
                case StopSelectionType.Regular:
                    this.circle.setStyle(this.selectionOptions);
                    break;
                case StopSelectionType.Start:
                    this.circle.setStyle(this.selectionStartOptions);
                    break;
                case StopSelectionType.GoBetween:
                    this.circle.setStyle(this.selectionGoBetweenOptions);
                    break;
                case StopSelectionType.End:
                    this.circle.setStyle(this.selectionFinishOptions);
                    break;
            }
        }
        else if (this.defaultOptions) {
            this.circle.setStyle(this.defaultOptions);
        }
    }

    select() {
        if (this.selectionOptions)
            this.circle.setStyle(this.selectionOptions);
        this.isSelected = true;
        this._selectionType = StopSelectionType.Regular;
    }
    selectAsStart() {
        if (this.selectionStartOptions)
            this.circle.setStyle(this.selectionStartOptions);
        this.isSelected = true;
        this._selectionType = StopSelectionType.Start;
    }
    selectAsFinish() {
        if (this.selectionFinishOptions)
            this.circle.setStyle(this.selectionFinishOptions);
        this.isSelected = true;
        this._selectionType = StopSelectionType.End;
    }
    selectAsGoBetween() {
        if (this.selectionGoBetweenOptions)
            this.circle.setStyle(this.selectionGoBetweenOptions);
        this.isSelected = true;
        this._selectionType = StopSelectionType.GoBetween;
    }

    unselect() {
        if (this._selectionType !== StopSelectionType.Regular
            && this._selectionType !== StopSelectionType.GoBetween) {
            return;
        }

        if (this.defaultOptions)
            this.circle.setStyle(this.defaultOptions);
        this.isSelected = false;
    }
    unselectDeep() {
        if (this.defaultOptions)
            this.circle.setStyle(this.defaultOptions);
        this.isSelected = false;
        this._selectionType = StopSelectionType.None;
    }

    enable() {
        let el = this.circle.getElement();
        L.DomUtil.removeClass(el, 'disabled-map-object');
        // let elBackground = this.circleBackground.getElement();
        // L.DomUtil.removeClass(elBackground, 'disabled-map-object');
    }

    disable() {
        let el = this.circle.getElement();
        L.DomUtil.addClass(el, 'disabled-map-object');
        // let elBackground = this.circleBackground.getElement();
        // L.DomUtil.addClass(elBackground, 'disabled-map-object');
    }
}

export enum StopSelectionType {
    None = 'none',
    Regular = 'regular',
    StartEnd = 'start-end',
    Start = 'start',
    End = 'end',
    GoBetween = 'go-betweeen',
}


// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/core/stop.ts